import { defineMessages } from "react-intl";

export const addTransactionMessages = defineMessages({
  captureTransaction: {
    defaultMessage: "Manual transaction",
    id: "biDgQS",
    description: "button, opens modal to create transaction in order",
  },
  markAsPaid: {
    defaultMessage: "Mark order as paid",
    id: "CrY98m",
    description: "button, marks order as paid (legacy payments)",
  },
});
